module.exports = __webpack_public_path__ + "img/article-header-preview-3.402def05.jpg";